import { objectsToSheetData, saveXlsx } from "./excelWriter";

//Exporta una lista de objetos a Excel (una hoja con una fila por objeto)
export function exportCleanExcel(data, fileName) {
  return saveXlsx([{ data: objectsToSheetData(data), sheet: "data" }], fileName);
}
